
namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    export class CustomerAddressDialog extends Serenity.EntityDialog<CustomerAddressRow, any> {
        protected getFormKey() { return CustomerAddressForm.formKey; }
        protected getIdProperty() { return CustomerAddressRow.idProperty; }
        protected getLocalTextPrefix() { return CustomerAddressRow.localTextPrefix; }
        protected getNameProperty() { return CustomerAddressRow.nameProperty; }
        protected getService() { return CustomerAddressService.baseUrl; }
        protected getDeletePermission() { return CustomerAddressRow.deletePermission; }
        protected getInsertPermission() { return CustomerAddressRow.insertPermission; }
        protected getUpdatePermission() { return CustomerAddressRow.updatePermission; }

        protected form = new CustomerAddressForm(this.idPrefix);

    }
}